import "./SuccessToast.css"

export function RichPlanToastMessage({ kind, count, dateLabel }) {
  return (
    <>
      <strong>
        {count} {count === 1 ? "Post" : "Posts"}
      </strong>
      {kind === "schedule" ? (
        <> scheduled in Calendar for </>
      ) : count === 1 ? (
        <> Added as Draft for </>
      ) : (
        <> Added as Drafts for </>
      )}
      <strong>{dateLabel}</strong>.
    </>
  )
}

export default function SuccessToast({
  message,
  children,
  subtext,
  actionLabel,
  onAction,
  onDismiss,
}) {
  const content = children ?? message
  if (content == null || content === "") return null

  const showAction = Boolean(actionLabel && onAction)

  return (
    <div className="success-toast-border">
      <div className="success-toast" role="status" aria-live="polite">
        <div className="success-toast__icon" aria-hidden>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>
        <div className="success-toast__body">
          <div className="success-toast__message">{content}</div>
          {subtext ? <div className="success-toast__subtext">{subtext}</div> : null}
        </div>
        {showAction ? (
          <button type="button" className="success-toast__action" onClick={onAction}>
            {actionLabel}
          </button>
        ) : onDismiss ? (
          <button
            type="button"
            className="success-toast__dismiss"
            onClick={onDismiss}
            aria-label="Dismiss notification"
            title="Dismiss"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        ) : null}
      </div>
    </div>
  )
}
